import { render, staticRenderFns } from "./advanced-tab.vue?vue&type=template&id=608896b1&scoped=true"
import script from "./advanced-tab.vue?vue&type=script&lang=js"
export * from "./advanced-tab.vue?vue&type=script&lang=js"
import style0 from "./advanced-tab.vue?vue&type=style&index=0&id=608896b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608896b1",
  null
  
)

export default component.exports